import "./Loader.css"

const Loader = () => {
    return(
        <div className="Loader">
            <div className="spinner"></div>
        </div>
    )
}

export default Loader;